import type { FC } from 'react';
import type { CalendarSelectionProps } from '../../types';

const CalendarSelection: FC<CalendarSelectionProps> = ({ options, selectedValue, onChange }) => (
  <>
    <div className="schedule-meeting-modal__divider" />
    <div className="schedule-meeting-modal__calendar-section">
      <div className="schedule-meeting-modal__input-label">Calendar</div>
      <div className="schedule-meeting-modal__calendar-options">
        {options.map(({ id, label }) => (
          <div className="schedule-meeting-modal__radio-option" key={id}>
            <input
              type="radio"
              id={id}
              name={`${id}-option`}
              className="schedule-meeting-modal__radio-input"
              checked={selectedValue === id}
              onChange={() => onChange(id)}
            />
            <label
              htmlFor={id}
              className="schedule-meeting-modal__radio-label schedule-meeting-modal__radio-label--bold"
            >
              {label}
            </label>
          </div>
        ))}
      </div>
    </div>
  </>
);

export default CalendarSelection;
